import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from './../config';
import common from '../common';
import $ from 'jquery';
import DreamTeam from './home/cards/DreamTeam';
import {
  shareTeamOfTheSeasonOnFacebook,
  shareTeamOfTheSeasonOnTwitter,
} from './../share';
import OutsideNotifier from './../OutsideNotifier';

class Endofseason extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoginCard: true,
      showTeamOfTheSeason: true,
      shouldMenuHamburgerOpen: false,
    };
    this.gameMenuItems = [];
  }
  
  openGame = (gameMenuItem) => {
    common.customTracking("Menu - Level 2 - Access " + gameMenuItem.name, null, "navigation");
    window.open(
      '//' +
        window.location.host +
        '/' +
        config.CURRENT_LANGUAGE +
        '/' +
        gameMenuItem.api_name,
      '_self'
    );
  }
  
  handleResize = () => {
    var mq = window.matchMedia('(max-width: 960px)');
    if (!mq.matches && this.state.shouldMenuHamburgerOpen) {
      this.setState({
        shouldMenuHamburgerOpen: false,
      });
    }
  };
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
    this.gameMenuItems = window.uefaGHComponent.getGames();
    if (common.isMobile()) {
      $('body').addClass('si-ty-main');
    }
    const COOKIE_GM = config.COOKIE_GM;
    let cookie = common.getCookie(COOKIE_GM);
    if (cookie) {
      this.setState({
        showLoginCard: false,
        showTeamOfTheSeason: false,
      });
    }
  }

  toggleMenu = (event, boolean) => {
    event.stopPropagation();
    this.setState({
      shouldMenuHamburgerOpen: boolean,
    });
  };

  goToGamingHub = () => {
    common.customTracking("Menu - Level 2 - Access " + "Gaming Hub", null, "navigation");
    window.open('//' + window.location.host, '_self');
  };

  goToPage = () => {
    common.customTracking("Menu - Level 2 - Access " + "Football Fantasy", null, "navigation");
    const COOKIE_GM = config.COOKIE_GM;
    let cookie = common.getCookie(COOKIE_GM);
    let cookieGM = common.parseCookie(cookie);
    if (cookie && cookieGM.HasTeam == 1) {
      return this.props.history.push('/manage-team');
    }
    if (!cookie) {
      return this.props.history.push('/');
    }
  };

  goToPlayStore() {
    // common.customTracking('Get App - Android', '/uclfantasy/end-of-season');
    window.open(
      'https://play.google.com/store/apps/details?id=com.uefa.eurofantasy'
    );
  }

  goToAppStore() {
    // common.customTracking('Get App - iOS', '/uclfantasy/end-of-season');
    window.open(
      'https://apps.apple.com/us/app/gaming-hub-uefa-champions-lea/id1107602457'
    );
  }

  render() {
    let trans = this.props.trans;
    let imgSrc = config.playerImgBase + 'EOT/';

    const defaultDreamTeamUrl =
      'https://gaming.uefa.com/en/uclfantasy/static/dreamteam/round{{name}}.html?v=15';
    // const DreamTeamUrl = (constraints.DreamTeamUrl || defaultDreamTeamUrl).replace('{{name}}', PtGameday);
    const DreamTeamUrl =
      'https://gaming.uefa.com/' + config.CURRENT_LANGUAGE + '/uclfantasy/';
    const DreamTeamTrans = {
      fb_dreamteam_share_caption: trans.teamOfTheSeasonShareCaption || '',
      fb_dreamteam_share_description:
        trans.teamOfTheSeasonShareDesc ||
        'Check out who made it to Team of the Season for Champions League',
    };
    let DTImg = config.DTImgUrl.replace(
      '{{PtGameday}}',
      config.teamOftheSeasonRoundNumber
    ); //FOR TEAM OF THE SEASON :100

    let DTDefaultImg = config.DTDefaultImgUrl;

    // return <div className="si-main-component si-no-anim si-leagues si-ty">
    //     <div className="si-container">
    //         <div className="si-ty__wrp">
    //             <div className="si-ty__head">
    //                 <img src={config.playerImgBase + "champion-leagues-logo@3x.png"} />
    //                 <div className="si-ty__head-title">
    //                     <span>{trans.eos1 ? trans.eos1 : "Thanks for playing"}</span>
    //                     {/* <span>{trans.eos2 ? trans.eos2 : "the official UEFA Champions League"}</span>
    //                     <span>{trans.eos3 ? trans.eos3 : "[GAME NAME]"}</span> */}
    //                 </div>
    //             </div>
    //             <div className="si-ty__body">
    //                 <div className="si-ty__body-cont">
    //                     <p>{trans.eos4 ? trans.eos4 : "Another fascinating UEFA Champions League season has come to a close but we are busy working on exciting new developments to offer you an amazing gaming experience next season."}</p>
    //                     <p>{trans.eos5 ? trans.eos5 : "Will keep you posted on this app about the forthcoming releases."}</p>
    //                     <p>{trans.eos6 ? trans.eos6 : ""}</p>
    //                 </div>

    //                 <div className="si-btn-wrp" onClick={() => window.open("//" + window.location.host, "_self")}>
    //                     <div className="si-btn si-btn-primary">
    //                         <span>{trans.eos7 ? trans.eos7 : "back to gaming hub"}</span>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // </div>

    return (
      <React.Fragment>
        <div
          className={ `${
            this.props.hideHeader
              ? 'si-ucl--menu si-hide-header'
              : 'si-ucl--menu '
            } ${this.state.shouldMenuHamburgerOpen ? 'si-open' : ''}` }>
          <div className='si-container'>
            <OutsideNotifier
              handler={ (e) => {
                this.toggleMenu(e, false);
              } }>
              <div
              className='si-menu--hamburger'
              onClick={(e) => {
                this.toggleMenu(e, true);
              }}>
              <span className='si-menu__txt'>
                {this.props.trans.menu_text
                  ? this.props.trans.menu_text
                  : 'MENU'}
              </span>
              <span className='si-menu__bar' />
              <span
                className='icon-ucl-close'
                onClick={(e) => {
                  this.toggleMenu(e, false);
                }}
              />
            </div>
            </OutsideNotifier>
            <div className='si-menu__dual'>
              <ul className='si-menu--top'>
                <li>
                  <a
                    onClick={ () => {
                      this.goToGamingHub();
                    } }>
                    { this.props.trans.menu_gaming_hub
                      ? this.props.trans.menu_gaming_hub
                      : 'GAMING HUB' }
                  </a>
                </li>
                <li>
                  <a
                    onClick={ () => {
                      this.goToPage();
                    } }>
                    { this.props.trans.fantasyClassic
                      ? this.props.trans.fantasyClassic
                      : 'FANTASY FOOTBALL' }
                  </a>
                </li>
              </ul>
              <ul className='si-menu--bottom'>
                <li>
                  <a href='javascript:void(0)' className='active'>
                    <span>
                      { this.props.trans.menu_end_of_season
                        ? this.props.trans.menu_end_of_season
                        : 'End of season' }
                    </span>
                  </a>
                </li>
              </ul>
              {
              this.gameMenuItems.length > 0 ? (
                <ul className='si-menu--bottom si-menu--gh'>
                  {this.gameMenuItems.map((gameMenuItem, index) => {
                      return (
                        <li key={index}>
                          <a
                            className={
                              config.APP_NAME == gameMenuItem.api_name
                                ? 'active'
                                : gameMenuItem.status == 'coming_soon'
                                ? 'si-disabled'
                                : ''
                            }
                            onClick={() => {
                              this.openGame(gameMenuItem);
                            }}>
                            <span>{gameMenuItem.name}</span>
                          </a>
                        </li>
                      );
                  })}
                </ul>
              ) : (
                ''
              )
            }
            </div>
          </div>
        </div>

        <div className='si-main-component si-eot'>
          <div className='si-container'>
            <div className='si-eot__row si-eot-banner'>
              <img src={ imgSrc + 'eot-img-1.png' } />
            </div>
            <div className='si-eot__row si-eot__card'>
              <div className='si-eot__title'>
                { trans.eosThankYouCardTitle
                  ? trans.eosThankYouCardTitle
                  : 'The UEFA Champions League 2019/20 has finished' }
              </div>
              <div className='si-eot__desc'>
                { trans.eosThankYouCardDesc
                  ? trans.eosThankYouCardDesc
                  : `As another action-packed season comes to a close, we're hard at
              work on exciting new developments to take your gaming experience
              next season to a whole new level. See you very soon!`}
              </div>
            </div>
            { this.state.showLoginCard ? (
              <div className='si-eot__row si-eot__card'>
                <div className='si-eot__title'>
                  { trans.eosLoginCardTitle
                    ? trans.eosLoginCardTitle
                    : 'Log in to see your final score' }
                </div>
                <div className='si-eot__desc'>
                  { trans.eosLoginCardDesc
                    ? trans.eosLoginCardDesc
                    : 'Did you compete in the 2019/20 season? Check out your final scores and see where you finished in each league' }
                </div>
                <div
                  className='si-btn si-btn-primary'
                  onClick={ () => {
                    window.uefaGHComponent.toogleMpsMenu();
                  } }>
                  { trans.eosLoginButton ? trans.eosLoginButton : 'Log in' }
                </div>
              </div>
            ) : (
                ''
              ) }
            { this.props.constraints.ShowOverallDreamTeam ? (
              <div
                className='si-eot__row si-eot__team'
                style={ { backgroundImage: 'url(' + DTImg + ')' } }
              />
            ) : null }
            { this.props.constraints.ShowOverallDreamTeam ? (
              <div className='si-eot__row si-eot__social'>
                { DreamTeamUrl ? (
                  <div className='si-social-card'>
                    <div className='si-social-share'>
                      <div className='si-title'>{ trans['share'] }:</div>
                      <div className='si-share-med'>
                        <div className='si-share-item si-fb-share'>
                          <i
                            className='icon-ucl-facebook'
                            onClick={ (e) =>
                              shareTeamOfTheSeasonOnFacebook(
                                e,
                                DreamTeamUrl,
                                DreamTeamTrans
                              )
                            }
                          />
                        </div>
                        <div className='si-share-item si-tweet-share'>
                          <i
                            className='icon-ucl-twitter'
                            onClick={ (e) =>
                              shareTeamOfTheSeasonOnTwitter(
                                e,
                                DreamTeamUrl,
                                DreamTeamTrans
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null }
              </div>
            ) : null }
          </div>
          <div className='si-eot__signup'>
            <div className='si-container'>
              <div className='si-eot__quiz'>
                <div className='si-quiz__img'>
                  <img src={ imgSrc + 'eot-img-mob.png' } className='si-mob' />
                  <img src={ imgSrc + 'eot-img-web.png' } className='si-web' />
                </div>
                <div className='si-eot__wrap'>
                  <div className='si-quiz__title'>
                    { trans.eosGamingHubApp
                      ? trans.eosGamingHubApp
                      : 'GAMING HUB APP' }
                  </div>
                  <div className='si-quiz__heading'>
                    { trans.eosProductTitle
                      ? trans.eosProductTitle
                      : 'Play the UEFA Champions League Quiz' }
                  </div>
                  <div className='si-quiz__desc'>
                    { trans.eosProductDesc
                      ? trans.eosProductDesc
                      : `Want to keep competing over the summer? Get the UEFA Gaming
                    Hub app and start playing the Quiz!`}
                  </div>
                  <div className='si-share--img si-flexBox'>
                    <a
                      href='Javascript:void(0)'
                      onClick={ this.goToPlayStore }
                      className='si-share__link si-ps'></a>
                    <a
                      href='Javascript:void(0)'
                      onClick={ this.goToAppStore }
                      className='si-share__link si-as'></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    trans: state.appData.trans,
    constraints: state.appData.constraints,
  };
};

export default connect(mapStateToProps, null)(Endofseason);



// WEBPACK FOOTER //
// ./src/components/Endofseason.js